/** EU/EEA ISO 3166-1 alpha-2 — Spain/EU privacy block applies */
const EU_COUNTRY_CODES = new Set([
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU',
  'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  'IS', 'LI', 'NO', 'CH', 'GB',
]);

/**
 * Detect privacy jurisdiction for registration UI.
 * @param {{ locale?: string, countryCode?: string }} [options]
 * @returns {'AU' | 'CO' | 'ES'}
 */
export function detectPrivacyJurisdiction(options = {}) {
  const rawLocale = (
    options.locale
    || (typeof navigator !== 'undefined' ? navigator.language : '')
    || ''
  ).trim();
  const normalized = rawLocale.replace(/_/g, '-');
  const lower = normalized.toLowerCase();
  const parts = normalized.split('-');
  const region = (parts[1] || '').toUpperCase();
  const cc = (options.countryCode || region || '').toUpperCase();

  if (cc === 'AU' || lower === 'en-au') return 'AU';
  if (cc === 'CO' || lower === 'es-co') return 'CO';
  if (cc === 'ES' || lower === 'es-es') return 'ES';
  if (EU_COUNTRY_CODES.has(cc)) return 'ES';

  const lang = (parts[0] || '').toLowerCase();
  if (lang === 'es' && cc !== 'CO' && lower !== 'es-co') return 'ES';

  const euRegionMatch = parts[1] && EU_COUNTRY_CODES.has(parts[1].toUpperCase());
  if (euRegionMatch) return 'ES';

  return 'AU';
}

export function isEuLocale(locale) {
  const j = detectPrivacyJurisdiction({ locale });
  return j === 'ES';
}
